<script setup lang="ts">
import { useAppStore } from '@/core/collections/app.store';
import { useUserInfoStore } from '@/core/collections/user-info/user-info.store';
import { useKeycloak } from '@future-harry/nxt-keycloak';
import { NxtIconButton, NxtPageHeader } from '@future-harry/nxt-styles';
import { Module } from '@future-harry/nxt-vue-library';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

const emits = defineEmits(['onShowSettingsPanel']);

const { decodedToken, keycloak } = useKeycloak();
const { t } = useI18n();
const appStore = useAppStore();
const { breadcrumbs } = storeToRefs(appStore);

const userInfoStore = useUserInfoStore();
const { userInfo } = storeToRefs(userInfoStore);

const baseUrl = window.location.origin;

//#region Bug Report
const bugReportUrl = computed(() => `${window.location.origin}/bug-report`);

function openBugReport() {
   window.open(bugReportUrl.value);
}
//#endregion
</script>

<template>
   <div class="page-header">
      <NxtPageHeader
         :user-info="userInfo"
         :fallback-username="decodedToken?.preferred_username"
         :modules="userInfo?.modules as Module[]"
         :user-actions="[
            {
               label: t('actions.log-out'),
               iconClass: 'fa-solid fa-arrow-right-from-bracket',
               to: keycloak.createLogoutUrl({ redirectUri: baseUrl }),
            },
         ]"
         :manage-organization-text="t('generic.manage-organisation')"
      >
         <template #breadcrumbs>
            <RouterLink
               v-for="(breadcrumb, index) in breadcrumbs"
               :key="index"
               v-bind="breadcrumb"
               :title="breadcrumb.to"
               :class="{ active: index === (breadcrumbs?.length || 0) - 1 }"
            >
               {{ breadcrumb.content }}
            </RouterLink>
         </template>

         <template #content>
            <div class="page-header__content"></div>
         </template>

         <template #pageActions>
            <div class="page-header__page-actions"></div>
         </template>

         <template #globalActions>
            <template v-if="userInfo?.scopes">
               <NxtIconButton :name="'bug'" :hover-text="$t('generic.feedback.report-bug')" @on-click="openBugReport" />

               <!-- Settings -->
               <NxtIconButton :name="'cog'" :hover-text="$t('settings.setting')" @on-click="emits('onShowSettingsPanel')" />
            </template>
            <NxtIconButton :name="'cog'" :hover-text="$t('settings.setting')" @on-click="emits('onShowSettingsPanel')" />
         </template>
      </NxtPageHeader>
      <div class="page-header__bottom">
         <slot />
      </div>
   </div>
</template>

<style lang="scss" scoped>
.page-header {
   border-bottom: 1px solid var(--nxt-light-grey);
}

.page-header__bottom {
   padding: var(--nxt-gutter) var(--nxt-gutter-large);
}
</style>
